import GreaterLessThanEasy from "../../components/ClassTwo/NumberMath/GreaterLessThanEasy";
import GreaterLessThanHard from "../../components/ClassTwo/NumberMath/GreaterLessThanHard";
import GreaterLessThanMedium from "../../components/ClassTwo/NumberMath/GreaterLessThanMedium";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/class-two/number-math/greater-less-than-easy", title: "Easy", component: GreaterLessThanEasy },
    { url: "/class-two/number-math/greater-less-than-medium", title: "Medium", component: GreaterLessThanMedium },
    { url: "/class-two/number-math/greater-less-than-hard", title: "Hard", component: GreaterLessThanHard }
];

export default topics;